export function setEmpleados(state, empleados) {
    state.empleados = empleados
}

export function setMessageContrasena(state, mess) {
    state.MessageContrasena = mess
}



export function actListEmpleados(state, empleado) {
    if (empleado !== null) {
        const index = state.empleados.findIndex(r => r.id === empleado.id)
        if (index != -1) {
            state.empleados.splice(index, 1, empleado)   
        }
    }
  
}

export function actDeleteListEmpleados(state, id) {
   
    if (id != null) {
        const index = state.empleados.findIndex(r => r.id === id)
        if (index != -1) {
            state.empleados.splice(index, 1)
        }
    }
}



export function setEmpleadoSelec(state, empleado) {
    state.empleadoSelec = empleado
}




